<template>
  <div class="h-100" style="position: static;">
    <loadingSpinner v-show="$store.state.ajaxManager.loadingRequests"></loadingSpinner>
    <router-view v-show="!$store.state['app-state'].isLoading"></router-view>
  </div>
</template>
<script>
import loadingSpinner from '@/components/LoadingSpinner.vue'
import {mapState} from 'vuex'
// import {defineAsyncComponent} from 'vue'

export default {
  computed: {
    ...mapState('ajaxManager', ['loadingRequests'])
  },
  components: {
      loadingSpinner,
    //tmtm: defineAsyncComponent(() => import('./components/Tmtm.vue' /* webpackChunkName: "TMTM" */))
  },
  beforeMount() {
    document.body.style.direction = this.$langConfig.dir;
    document.body.style.textAlign = this.$langConfig.align;
  }
}
</script>
